import axios from 'core/network/interceptor';
import { GetContractsUrl } from './constants';

const GetContractsRequest = async (temp_worker_id: number) => {
    const response = await axios.get(GetContractsUrl(temp_worker_id));

    return response.data.contracts;
};

export { GetContractsRequest }